import IMask from "imask";

export default function initPhoneMask(inputTel) {
  IMask(inputTel, {
    mask: "+{7} (000) 000-00-00",
  });
}
